import { useMutation } from 'react-query'
import { postJSON } from 'common/services/api'
import { Resident } from '@lmc/ts-common'
import { handleErrorResponse } from 'utils/error'

export type GetTemplate = {
  result: { resident: Resident }
}

export const useCreateTemplates = (homeId: string, onSuccess?: () => void) => {
  const mutationFunction = (): Promise<{ result: GetTemplate }> =>
    postJSON({
      url: `list/homes/${homeId}/data-from-template`,
      method: 'POST',
    })

  const { mutateAsync, isLoading, error, reset } = useMutation(
    mutationFunction,
    {
      onSuccess,
    }
  )

  return {
    isLoading,
    createTemplateData: mutateAsync,
    error: handleErrorResponse(error),
    reset,
  }
}
